const NAME = "ISSUE_LICENCES";

export default NAME;
